export enum SearchModePublic {
  Fulltext = 'fulltext',
  Simple = 'simple',
}
